import React, { useEffect, useState, useContext } from 'react';
import {
  Ref,
  Form,
  Radio,
  Checkbox,
  Input,
  Button as ButtonSource
} from 'semantic-ui-react';
import { useNode, useEditor } from '@craftjs/core';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Placeholdermodal from './PlaceholderModal';
import { DocumentFieldsContext } from '../../Template/DocumentFieldsContext';

export const Button = ({ size, fluid, color, btnText, fieldName }) => {
  const {
    connectors: { connect, drag },
    actions: { setCustom }
  } = useNode();
  const { t } = useTranslation();

  useEffect(() => {
    setCustom((props) => {
      props.displayName = t('button');
    });
  }, [setCustom, t]);

  const isSmall = size === 'small';

  return (
    <Ref innerRef={(ref) => connect(drag(ref))}>
      <button
        style={{
          margin: '5px',
          backgroundColor: '#2185d0',
          height: isSmall ? '36px' : '43px',
          padding: isSmall ? '10px 15px' : '13px 20px',
          border: 'none',
          borderRadius: '4px',
          width: fluid ? '98%' : '',
          textAlign: 'center'
        }}
      >
        <a
          data-th-href={'@{${' + fieldName + '}}'}
          target='_blank'
          style={{
            color: '#FFF',
            fontSize: isSmall ? '0.9rem' : '1.14rem',
            textAlign: 'center'
          }}
        >
          {btnText === '' ? t('click_me') : btnText}
        </a>
      </button>
    </Ref>
  );
};

export const ButtonSettings = () => {
  const { documentJson } = useContext(DocumentFieldsContext);
  const {
    actions: { setProp },
    size,
    fluid,
    btnText,
    parent,
    fieldName
  } = useNode(({ data }) => ({
    parent: data.parent,
    fieldName: data.props.fieldName,
    size: data.props.size,
    fluid: data.props.fluid,
    btnText: data.props.btnText
  }));

  const { t } = useTranslation();

  const [showModal, setShowModal] = useState({
    show: false,
    listSource: '',
    parent: '',
    showRootFields: true,
    action: null
  });
  const { currentState } = useEditor((state) => ({
    currentState: state
  }));

  // eslint-disable-next-line no-param-reassign
  const handleForm = (_, data) => {
    setProp((props) => {
      props[data.name] = data.value;
    });
  };

  const handleCheck = (_, data) =>
    setProp((props) => {
      props.fluid = data.checked;
    });

  const changeText = (newValue) => {
    setProp((props) => {
      props.fieldName = newValue;
    }, 500);
  };

  const onClick = (e, data) => {
    let listId =
      currentState.nodes[parent]?.dom?.localName !== 'th'
        ? currentState.nodes[parent]?.data?.parent
        : null;
    let listSrc = currentState.nodes[listId]?.data?.props?.listSrc;

    setShowModal({
      show: true,
      listSource: listSrc,
      parent: '',
      showRootFields: typeof listSrc === 'undefined',
      action: data.name
    });
  };

  return (
    <div>
      <Placeholdermodal
        currentValue={fieldName}
        documentJson={documentJson}
        showModal={showModal}
        changeTextFunc={changeText}
        setShowModal={setShowModal}
        setProp={setProp}
      />

      <Form size='small'>
        <Form.Field>
          <ButtonSource name='source' onClick={onClick}>
            {t('select_source')}
          </ButtonSource>
        </Form.Field>
        <Form.Field component='legend'>{t('size')}</Form.Field>
        <Form.Group inline>
          <Form.Field
            control={Radio}
            label={t('small')}
            name='size'
            value='small'
            checked={size === 'small'}
            onChange={handleForm}
          />
          <Form.Field
            control={Radio}
            label={t('large')}
            name='size'
            value='large'
            checked={size === 'large'}
            onChange={handleForm}
          />
        </Form.Group>
        <Form.Field component='legend'>{t('fluid_header')}</Form.Field>
        <Form.Group inline>
          <Form.Field
            control={Checkbox}
            label={t('fluid_btn')}
            name='fluid'
            checked={fluid}
            onChange={handleCheck}
          />
        </Form.Group>
        <Form.Field component='legend'>{t('btn_text')}</Form.Field>
        <Form.Group inline>
          <Form.Field
            control={Input}
            name='btnText'
            value={btnText}
            onChange={handleForm}
          />
        </Form.Group>
      </Form>
    </div>
  );
};

export const ButtonDefaultProps = {
  fieldName: '',
  size: 'small',
  btnText: '',
  fluid: false
};

Button.defaultProps = ButtonDefaultProps;

Button.propTypes = {
  fieldName: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  btnText: PropTypes.string,
  fluid: PropTypes.bool
};

Button.craft = {
  props: ButtonDefaultProps,
  related: {
    settings: ButtonSettings
  }
};
